<template>
  <div class="page-container d-flex align-items-center justify-content-center login-page-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-5">
          <!-- Login Card -->
          <div class="theme-card login-card animated-entry">
            <!-- Icon/Logo Area -->
            <div class="icon-wrapper mb-4">
              <i class="fas fa-user-graduate"></i>
            </div>
            
            <h2 class="card-title text-center mb-1">STUDENT PORTAL</h2>
            <p class="card-description text-center mb-4">Sila log masuk untuk meneruskan</p>

            <div class="card-content w-100">
              <form @submit.prevent="submitLogin()">
                <div class="form-group mb-4">
                  <label for="username" class="input-label">No. Identitas Mahasiswa</label>
                  <div class="input-group-theme">
                    <div class="input-icon">
                      <i class="fas fa-id-card"></i>
                    </div>
                    <input 
                      id="username"
                      v-model="username" 
                      type="text" 
                      class="form-control theme-input" 
                      :class="{'is-invalid': serverError.username}" 
                      placeholder="Masukkan No. Identitas"
                    />
                  </div>
                  <div class="error-message" v-if="serverError.username">
                    <i class="fas fa-exclamation-circle mr-1"></i> {{serverError.username[0]}}
                  </div>
                </div>

                <div class="form-group mb-5">
                  <label for="password" class="input-label">Password</label>
                  <div class="input-group-theme">
                    <div class="input-icon">
                      <i class="fas fa-lock"></i>
                    </div>
                    <input 
                      id="password"
                      v-model="password" 
                      type="password" 
                      class="form-control theme-input" 
                      :class="{'is-invalid': serverError.password}" 
                      placeholder="Masukkan Password"
                    />
                  </div>
                  <div class="error-message" v-if="serverError.password">
                    <i class="fas fa-exclamation-circle mr-1"></i> {{serverError.password[0]}}
                  </div>
                </div>

                <button :disabled="disabled" type="submit" class="btn btn-light btn-lg btn-block btn-login font-weight-bold">
                  <span v-if="disabled">
                    <i class="fas fa-spinner fa-spin mr-2"></i> SEDANG LOG MASUK...
                  </span>
                  <span v-else>
                    MASUK SEKARANG <i class="fas fa-arrow-right ml-2"></i>
                  </span>
                </button>
              </form>
            </div>
          </div>

          <!-- Help Section -->
           <!-- <div class="text-center mt-4 text-muted small">
            <p class="mb-2">Ada masalah log masuk?</p>
            <a href="https://lin.ee/w2wVEIl" target="_blank" class="text-decoration-none">
              <img height="36" border="0" src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png" alt="Add Friend">
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
// import { Form, HasError, AlertError } from "vform";
// Vue.component(HasError.name, HasError);
// Vue.component(AlertError.name, AlertError);
import axios from "axios";

export default {
  data() {
    return {
      disabled: false,
      username: "",
      password: "",
      device_name: "browser",
      serverError: {},
    };
  },
  methods: {
    login(){
      this.disabled = true;
      this.$store.dispatch('authentication/signIn', {
        username: this.username,
        password: this.password,
      })
        .then(() => {
          this.disabled = false;
          this.$Progress.finish();
          this.$router.push({ name: 'Menu' });
          this.serverError = {};
        })
        .catch(error => {
            if(error.response.status == 401 || error.response.status == 419){
              this.$store.dispatch("authentication/cencelAuthen");
            } 
          this.serverError = error.response.data.errors;
          this.disabled = false;
          this.$Progress.fail();
        })
    },
    submitLogin(){
      this.disabled = true;
      this.$Progress.start();
      const request = axios.create({
        baseURL: process.env.VUE_APP_URL_COOKIE,
        withCredentials: true,
      });
      request.get('/sanctum/csrf-cookie')
        .then(() => {
          this.login();
        })
    }
  },
};
</script>

<style scoped>
.login-page-container {
  min-height: 85vh;
  background: transparent;
}

/* Custom Styles for Login Card specifically */
.login-card {
  border-radius: 24px;
  padding: 40px 30px;
  overflow: visible; /* Allow content to flow nicely */
}

/* Input Styles Overlay */
.input-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  margin-bottom: 8px;
  font-weight: 500;
}

.input-group-theme {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 15px;
  color: var(--primary-color);
  z-index: 10;
  font-size: 1.1rem;
}

.theme-input {
  height: 50px;
  padding-left: 45px;
  border-radius: 12px;
  border: 2px solid transparent;
  background: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  transition: all 0.3s ease;
  color: var(--primary-dark);
}

.theme-input:focus {
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  outline: none;
}

.theme-input::placeholder {
  color: #adb5bd;
}

.btn-login {
  height: 54px;
  border-radius: 12px;
  color: var(--primary-color);
  font-size: 1.1rem;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: none;
}

.btn-login:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  background: #ffffff;
}

.btn-login:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.error-message {
  color: #ffadad;
  font-size: 0.85rem;
  margin-top: 6px;
  animation: slideDown 0.3s ease-out;
}

/* Entry Animation */
.animated-entry {
  animation: entryFade 0.6s ease-out;
}

@keyframes entryFade {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Adjustments */
@media (max-width: 576px) {
  .login-card {
    padding: 30px 20px;
    border-radius: 20px;
  }
  
  .icon-wrapper {
    width: 70px;
    height: 70px;
  }
  
  .icon-wrapper i {
    font-size: 2rem;
  }
}
</style>